import React, { useEffect, useState } from "react";

import { Admin, ContactNo, Designation, Email, Submit, SuperAdmin } from "../../Constant";

import {
  formFields,
  hrEnums,
  MANDATORY_DOCUMENT_TYPES,
  MANDATORY_DOC_VALUES,
} from "../../Constant/HR_Staff/hrEnums";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useFormik } from "formik";

import * as yup from "yup";

import BankDetails from "./bankDetails";

import EmploymentDetails from "./employmentDetails";

import ProfileDetails from "./profileDetails";

import PersonalDetails from "./personalDetails";

import GeneralDetails from "./generalDetails";

import {
  aadharRegex,
  numberRegex,
  panRegex,
  validationMessages,
  ifscRegex,
  zipcodeRegex,
  emailRegex,
} from "../../Constant/validation";

import { toast } from "react-toastify";
import { getDefaultLetterBody, downloadLetterPdf } from "../../utils/letterUtils";
import { getLetterConfigApi } from "../../Api/letterSettingsApi";

import {
  centerApi,
  fileUploadApi,
  listOfDistrict,
  listOfState,
  listOfSubscriptionApi,
} from "../../Api/common";

import BaseButton from "../../BaseComponents/BaseButton";
import BaseModal from "../../BaseComponents/BaseModal";
import BaseDatePicker from "../../BaseComponents/BaseDatePicker";
import BaseInput from "../../BaseComponents/BaseInput";
import BaseCheckbox from "../../BaseComponents/BaseCheckbox";
import BaseSelect from "../../BaseComponents/BaseSelect";

import { useSelectedOrganization } from "../OrganizationContext";

import { listOfPositionApi } from "../../Api/positionApi";

import {
  addStaffApi,
  editStaffApi,
  listOfHolidayApi,
  listOfLeaveTemplateApi,
  listOfRoleStaffApi,
  listOfShiftApi,
  listOfStaffApi,
  viewProfileApi,
  viewStaffApi,
  viewStaffIDApi,
  resetEmailApi,
} from "../../Api/HRStaffApi";

import { attendanceDataApi } from "../../Api/AttendenceMode";

import {
  checkStatusCodeSuccess,
  deleteUploadedfile,
  getLocalItem,
  isUserProfile,
  rendorBackButton,
  setItem,
  staff,
  errHandler,
  getItem,
} from "../../Constant/common";

import {
  migrateLegacyDocument,
  migrateFlatDocuments,
  validateFileForUpload,
  buildDocumentPayload,
  parseIdentifyDocument,
  removeAt,
} from "../../Constant/HR_Staff/documentHelpers";

import { usePageLoader } from "../../_helper/loading/LoadingContext";

import { useSelectedCenter } from "../CenterContext";

import { listOfOrganizationApi, viewOrganizationApi } from "../../Api/OrganizationApi";
import { bankListApi } from "../../Api/bankApi";

const StaffProfile = ({ isOnboarding = false, onSuccess }) => {
  const location = useLocation();

  const { selectedCenter, selectedCenterPayload } = useSelectedCenter();

  const { selectedOrganization } = useSelectedOrganization();

  const organizationIdFromState = location.state?.organizationId;

  const [viewProfileMode, setViewProfileMode] = useState(false);

  const [viewGeneralMode, setViewGeneralMode] = useState(false);

  const [viewPersonalMode, setViewPersonalMode] = useState(false);

  const [viewEmploymentMode, setViewEmploymentMode] = useState(false);

  const [viewBankMode, setViewBankMode] = useState(false);

  const [editProfileMode, setEditProfileMode] = useState(false);

  const [editPersonalMode, setEditPersonalMode] = useState(false);

  const [editGeneralMode, setEditGeneralMode] = useState(false);

  const [editEmploymentMode, setEditEmploymentMode] = useState(false);

  const [editBankMode, setEditBankMode] = useState(false);

  const [selectedPhysical, setSelectedPhysical] = useState(hrEnums.NO);

  const [selectedGender, setSelectedGender] = useState(hrEnums.MALE);

  // Letter generation states
  const [letterModal, setLetterModal] = useState(false);
  const [letterModalLoader, setLetterModalLoader] = useState(false);
  const [letterDesignation, setLetterDesignation] = useState("");
  const [letterRelievingDate, setLetterRelievingDate] = useState(new Date());
  const [letterDate, setLetterDate] = useState(new Date());
  const [letterType, setLetterType] = useState("joining");
  const [letterBody, setLetterBody] = useState("");
  const [includeSignature, setIncludeSignature] = useState(true);
  const [signatory, setSignatory] = useState("HR Manager");

  const { setLoading: setLoader } = usePageLoader();

  const [district, setDistrict] = useState([]);

  const [states, setStates] = useState([]);

  const [positionData, setPositionData] = useState([]);

  const [roleData, setRoleData] = useState([]);

  const [centerData, setCenterData] = useState([]);
  const [loadedOrgIdForCenters, setLoadedOrgIdForCenters] = useState(null);

  const [staffData, setStaffData] = useState(null);

  const [reportingManager, setReportingManager] = useState([]);

  const [btnLoader, setBtnLoader] = useState(false);

  const [selectedMulti, setSelectedMulti] = useState([]);

  const [lastStaffId, setLastStaffId] = useState(null);

  const [currentStaffId, setCurrentStaffId] = useState(null);

  const [holidayData, setHolidayData] = useState([]);

  const [shiftData, setShiftData] = useState([]);

  const [leaveData, setLeaveData] = useState([]);

  const [isChecked, setIsChecked] = useState(false);

  const [selectedMultiCenter, setSelectedMultiCenter] = useState([]);

  const [attendaceMode, setAttendenceMode] = useState([]);

  const [uploadingIndex, setUploadingIndex] = useState(null);

  const [selectedCenterIds, setSelectedCenterIds] = useState([]);

  const [showResetEmailModal, setShowResetEmailModal] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [resetEmailError, setResetEmailError] = useState("");
  const [resetEmailLoader, setResetEmailLoader] = useState(false);

  const [subscriptionList, setSubscriptionList] = useState([]);

  const [organizationList, setOrganizationList] = useState([]);

  const [organizationCenters, setOrganizationCenters] = useState([]);

  const [organizationDesignations, setOrganizationDesignations] = useState([]);

  const [bankList, setBankList] = useState([]);

  const [overtimePolicyType, setOvertimePolicyType] = useState(null);

  const isSuperAdmin = localStorage.getItem("role") === SuperAdmin;

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role === SuperAdmin || role === Admin) {
      listOfSubscriptionApi()
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.statusCode)) {
            const options = resp?.data?.map((item) => ({
              value: item.id,

              label: item.plan_name,
            }));

            setSubscriptionList(options);
          }
        })

        .catch((err) => {
          return err;
        });
    }
  }, []);

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role === SuperAdmin) {
      listOfOrganizationApi()
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.statusCode)) {
            const options = resp?.data?.listOfOrganizations?.map((item) => ({
              value: item.id,

              label: item.organization_name,
            }));

            setOrganizationList(options);
          }
        })

        .catch((err) => {
          return err;
        });
    }
  }, []);

  /* ── Fetch bank list (all banks, no pagination filter) ── */
  useEffect(() => {
    bankListApi({
      ...selectedCenterPayload,
      order: ["id", "desc"],
      pageSize: 1000,
      pageNumber: 1,
    })
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          setBankList(
            (resp?.data?.listOfBanks || resp?.data || []).map((item) => ({
              value: item?.bank_name || item?.name || item?.id,
              label: item?.bank_name || item?.name || String(item?.id),
            })),
          );
        }
      })
      .catch(() => {});
  }, [selectedCenterPayload]);

  useEffect(() => {
    const role = localStorage.getItem("role");

    const orgId = localStorage.getItem("organizationId");

    if (role !== SuperAdmin && orgId) {
      const numericOrgId = Number(orgId);

      listOfPositionApi({ condition: { organizationId: numericOrgId } })
        .then((resp) => {
          if (checkStatusCodeSuccess(resp.statusCode)) {
            setOrganizationDesignations(
              resp.data?.listOfPosition.map((item) => ({
                value: item.id,

                label: item.position_name,

                id: item.id,
              })),
            );
          }
        })

        .catch(() => {});

      centerApi({ condition: { organizationId: numericOrgId } })
        .then((resp) => {
          if (checkStatusCodeSuccess(resp.statusCode)) {
            setOrganizationCenters(
              resp.data?.map((item) => ({
                value: item.id,

                label: item.center_name,

                id: item.id,
              })),
            );
          }
        })

        .catch(() => {});

      const roleOrgId = isSuperAdmin
        ? (organizationIdFromState ?? selectedOrganization)
        : localStorage.getItem("organizationId");
      listOfRoleStaffApi(null, roleOrgId)
        .then((resp) => {
          if (checkStatusCodeSuccess(resp.statusCode)) {
            setRoleData(
              resp?.data?.map((item) => ({
                value: item?.id,

                label: item?.role_name,

                id: item?.id,
              })),
            );
          }
        })

        .catch(() => {});
    }
  }, [isSuperAdmin, organizationIdFromState, selectedOrganization]);

  const handleOrganizationChange = (selectedOrg) => {
    staffForm.setFieldValue("organization", selectedOrg ?? null);

    const orgId =
      selectedOrg?.id ??
      selectedOrg?.value ??
      (typeof selectedOrg === "number" ? selectedOrg : null);

    if (orgId) {
      listOfPositionApi({ condition: { organizationId: orgId } })
        .then((resp) => {
          if (checkStatusCodeSuccess(resp.statusCode)) {
            setOrganizationDesignations(
              resp.data?.listOfPosition.map((item) => ({
                value: item.id,

                label: item.position_name,

                id: item.id,
              })),
            );
          } else {
            setOrganizationDesignations([]);
          }
        })

        .catch(() => setOrganizationDesignations([]));

      const organization_id = location.state?.organizationId;

      centerApi({
        condition: {
          organizationId: organization_id ? organization_id : orgId,
        },
      })
        .then((resp) => {
          if (checkStatusCodeSuccess(resp.statusCode)) {
            setOrganizationCenters(
              resp.data?.map((item) => ({
                value: item.id,

                label: item.center_name,

                id: item.id,
              })),
            );
          } else {
            setOrganizationCenters([]);
          }
        })

        .catch(() => setOrganizationCenters([]));
    } else {
      setOrganizationDesignations([]);

      setOrganizationCenters([]);
    }
  };

  const isEditMode =
    editProfileMode || editGeneralMode || editPersonalMode || editEmploymentMode || editBankMode;

  const navigate = useNavigate();

  const addressDetails = staffData?.staffAddress?.map((item) => {
    return item;
  });

  const { staffId } = useParams();

  const profileId = getLocalItem("id");

  const isProfile = location.pathname === "/profile";

  const isAddStaff = location.pathname === "/staffProfile" || isOnboarding;

  // const { selectedCenterPayload } = useSelectedCenter();

  const fieldToSectionMap = {
    profile: [
      formFields.first_name,

      formFields.middle_name,

      formFields.last_name,

      formFields.designation,

      formFields.role,

      formFields.staff_type,

      formFields.email,

      formFields.contact_no,

      formFields.center,

      formFields.primary_center_id,

      formFields.reporting_manager,

      formFields.staff_id,

      formFields.subscription,

      formFields.organization,
    ],

    general: [
      formFields.week_off,

      formFields.holiday_template,

      formFields.leave_template,

      formFields.shift,

      formFields.salary_access,

      formFields.attendance_mode,
    ],

    personal: [
      formFields.gender,

      formFields.dob,

      formFields.blood_group,

      formFields.emergency_contact,

      formFields.physically_challenged,

      formFields.father_name,

      formFields.mother_name,

      formFields.marital_status,

      formFields.spouse_name,

      formFields.address_line1,

      formFields.address_line2,

      formFields.state,

      formFields.district,

      formFields.postal_code,

      formFields.permanent_address_line1,

      formFields.permanent_address_line2,

      formFields.permanent_district,

      formFields.permanent_state,

      formFields.permanent_postal_code,
    ],

    bank: [
      formFields.bank_name,

      formFields.ifsc,

      formFields.account_number,

      formFields.account_holder_name,
    ],

    employment: [
      formFields.joining_date,
      formFields.uan,
      formFields.pan,
      formFields.aadhar_number,
      formFields.documents,
    ],
  };

  const handleProfileEdit = () => {
    setEditProfileMode(true);

    setViewProfileMode(false);
  };

  const handleGeneralEdit = () => {
    setEditGeneralMode(true);

    setViewGeneralMode(false);
  };

  const handlePersonalEdit = () => {
    setEditPersonalMode(true);

    setViewPersonalMode(false);
  };

  const handleEmploymentEdit = () => {
    setEditEmploymentMode(true);

    setViewEmploymentMode(false);
  };

  const handleBankEdit = () => {
    setEditBankMode(true);

    setViewBankMode(false);
  };

  const handleProfileDiscard = () => {
    setEditProfileMode(false);

    setViewProfileMode(true);
  };

  const handleGeneralDiscard = () => {
    setEditGeneralMode(false);

    setViewGeneralMode(true);
  };

  const handlePersonalDiscard = () => {
    setEditPersonalMode(false);

    setViewPersonalMode(true);
  };

  const handleEmploymentDiscard = () => {
    setEditEmploymentMode(false);

    setViewEmploymentMode(true);
  };

  const handleBankDiscard = () => {
    setEditBankMode(false);

    setViewBankMode(true);
  };

  const handleGenerateJoiningLetter = (data) => {
    const activeStaff = data || staffData || JSON.parse(getItem("staffData"));
    setLetterType("joining");
    setLetterDesignation(activeStaff?.position?.position_name || "");
    setLetterDate(new Date());
    setLetterRelievingDate(new Date());
    setLetterBody(
      getDefaultLetterBody(
        "joining",
        activeStaff,
        new Date(),
        new Date(),
        activeStaff?.position?.position_name,
      ),
    );
    setLetterModal(true);
  };

  const handleGenerateExperienceLetterClick = (data) => {
    const activeStaff = data || staffData || JSON.parse(getItem("staffData"));
    setLetterType("experience");
    setLetterDesignation(activeStaff?.position?.position_name || "");
    setLetterDate(new Date());
    setLetterRelievingDate(new Date());
    setLetterBody(
      getDefaultLetterBody(
        "experience",
        activeStaff,
        new Date(),
        new Date(),
        activeStaff?.position?.position_name,
      ),
    );
    setLetterModal(true);
  };

  const handleDownloadLetter = async () => {
    const activeStaff = staffData || JSON.parse(getItem("staffData"));
    if (!activeStaff) {
      toast.error("Staff details not found.");
      return;
    }
    setLetterModalLoader(true);

    try {
      let settings = {
        includeLogo: true,
        includeSignature: includeSignature,
        signatoryName: signatory || "Authorized Signatory",
        signatoryTitle: "Authorized Signatory",
      };

      try {
        const configRes = await getLetterConfigApi();
        if (checkStatusCodeSuccess(configRes?.statusCode) && configRes?.data?.settings) {
          const s = configRes.data.settings;
          settings = {
            includeLogo: s.include_logo ?? true,
            logoPath: s.logo_path || "",
            logoWidth: s.logo_width ? String(s.logo_width) : "120",
            logoAlign: s.logo_align || "left",
            includeSignature: includeSignature,
            signatoryName: signatory || s.signatory_name || "Authorized Signatory",
            signatoryTitle: s.signatory_title || "Authorized Signatory",
            signaturePath: s.signature_path || "",
          };
        }
      } catch (e) {
        // Fall back to default settings
      }

      const docName = letterType === "joining" ? "Joining_Letter" : "Experience_Letter";
      await downloadLetterPdf(docName, activeStaff, letterBody, settings);

      toast.success(
        `${letterType === "joining" ? "Joining" : "Experience"} Letter PDF downloaded successfully.`,
      );
      setLetterModal(false);
    } catch (err) {
      errHandler(err);
      toast.error(
        `Failed to download ${letterType === "joining" ? "Joining" : "Experience"} Letter.`,
      );
    } finally {
      setLetterModalLoader(false);
    }
  };

  const fetchData = () => {
    let data;

    if (!isEditMode && !isAddStaff) {
      setLoader(true);

      const apiCall = isProfile ? viewProfileApi : viewStaffApi;

      apiCall(isProfile ? "" : staffId)
        .then((resp) => {
          if (checkStatusCodeSuccess(resp.statusCode)) {
            data = resp?.data;

            setStaffData(data);

            if (data?.organization?.overtime_policy_type) {
              setOvertimePolicyType(data?.organization?.overtime_policy_type);
            }

            setSelectedGender(data?.staffGeneralInformation?.gender);

            setSelectedPhysical(data?.staffGeneralInformation?.physically_challenged);

            let editweek = data?.assignedWeekOff?.map((item) => ({
              value: item?.week_off,

              label: item?.week_off,
            }));

            let center = data?.center?.map((item) => ({
              value: item?.id,

              label: item?.center_name,
            }));

            handleMultiCenter(center);

            handleMulti(editweek);

            let staffDetails = {
              name: data?.name,

              id: data?.staffGeneralInformation?.staff_id,

              isActive: data?.isActive,
            };

            setItem("staffData", JSON.stringify(staffDetails));

            window.dispatchEvent(new Event("staffDataUpdated"));
          } else {
            toast.error(resp?.message);
          }
        })

        .catch((err) => {
          return err;
        })

        .finally(() => {
          setLoader(false);
        });
    }

    if (isEditMode || isAddStaff || (isProfile && isEditMode)) {
      if (states.length === 0) {
        setLoader(true);

        listOfState()
          .then((resp) => {
            if (checkStatusCodeSuccess(resp.statusCode)) {
              data = resp?.data;

              setStates(
                data?.map((item) => ({
                  value: item?.id,

                  label: item?.state_name,

                  id: item?.id,
                })),
              );
            } else {
              setStates([]);

              toast.error(resp?.message);
            }
          })

          .catch((err) => {
            setStates([]);

            return err;
          })

          .finally(() => {
            setLoader(false);
          });
      }

      const currentOrgId =
        isSuperAdmin && location.state?.organizationId
          ? location.state?.organizationId
          : localStorage.getItem("organizationId")
            ? Number(localStorage.getItem("organizationId"))
            : null;

      if (centerData.length === 0 || loadedOrgIdForCenters !== currentOrgId) {
        setLoader(true);
        const centerApiPayload =
          isSuperAdmin && location.state?.organizationId
            ? { condition: { organizationId: location.state?.organizationId } }
            : localStorage.getItem("organizationId")
              ? {
                  condition: {
                    organizationId: localStorage.getItem("organizationId"),
                  },
                }
              : {};

        centerApi(centerApiPayload)
          .then((resp) => {
            if (checkStatusCodeSuccess(resp.statusCode)) {
              data = resp?.data;

              setLoadedOrgIdForCenters(currentOrgId);
              setCenterData(
                data?.map((item) => ({
                  value: item?.id,

                  label: item?.center_name,

                  id: item?.id,
                })),
              );
            } else {
              setCenterData([]);
              setLoadedOrgIdForCenters(null);

              toast.error(resp?.message);
            }
          })

          .catch((err) => {
            setCenterData([]);
            setLoadedOrgIdForCenters(null);

            return err;
          })
          .finally(() => {
            setLoader(false);
          });
      }

      if (positionData.length === 0) {
        setLoader(true);
        listOfPositionApi()
          .then((resp) => {
            if (checkStatusCodeSuccess(resp.statusCode)) {
              let data = resp?.data?.listOfPosition;

              setPositionData(
                data?.map((item) => ({
                  value: item?.id,

                  label: item?.position_name,

                  id: item?.id,
                })),
              );
            } else {
              setPositionData([]);
            }
          })

          .catch((err) => {
            setPositionData([]);

            return err;
          })

          .finally(() => {
            setLoader(false);
          });
      }

      const role = localStorage.getItem("role");
      if (roleData.length === 0 && (role === SuperAdmin || role === Admin)) {
        setLoader(true);
        const roleOrgId = isSuperAdmin
          ? (location.state?.organizationId ?? selectedOrganization)
          : localStorage.getItem("organizationId");

        listOfRoleStaffApi(null, roleOrgId)
          .then((resp) => {
            if (checkStatusCodeSuccess(resp.statusCode)) {
              let data = resp?.data;

              setRoleData(
                data?.map((item) => ({
                  value: item?.id,

                  label: item?.role_name,

                  id: item?.id,
                })),
              );
            } else {
              setRoleData([]);
            }
          })

          .catch((err) => {
            setRoleData([]);

            return err;
          })

          .finally(() => {
            setLoader(false);
          });
      }

      if (attendaceMode.length === 0) {
        setLoader(true);

        attendanceDataApi()
          .then((resp) => {
            if (checkStatusCodeSuccess(resp?.statusCode)) {
              setAttendenceMode(resp?.data?.value);
            } else {
              toast.error(resp?.message);
            }
          })

          .catch((err) => {
            return err;
          })

          .finally(() => {
            setLoader(false);
          });
      }
    }

    if (isAddStaff && !currentStaffId) {
      setLoader(true);

      const organizationId = location.state?.organizationId;

      viewStaffIDApi(organizationId)
        .then((resp) => {
          if (checkStatusCodeSuccess(resp.statusCode)) {
            data = resp?.data;

            setCurrentStaffId(data?.currentStaffID);

            setLastStaffId(data?.lastStaffID);
          } else {
            toast.error(resp?.message);
          }
        })

        .catch((err) => {
          return err;
        })

        .finally(() => {
          setLoader(false);
        });
    }
  };

  const fetchDistrict = (id) => {
    setLoader(true);

    let data;

    const payload = {
      condition: {
        state_id: id,
      },
    };

    listOfDistrict(payload)
      .then((resp) => {
        if (checkStatusCodeSuccess(resp.statusCode)) {
          data = resp?.data;

          setDistrict(
            data?.map((item) => ({
              value: item?.id,

              label: item?.district_name,

              id: item?.id,
            })),
          );
        } else {
          setDistrict([]);

          toast.error(resp?.message);
        }
      })

      .catch((err) => {
        setDistrict([]);

        return err;
      })

      .finally(() => {
        setLoader(false);
      });
  };

  const fetchReportingManager = (centerId) => {
    let data;

    const payload = {
      center_ids: Array.isArray(centerId) ? centerId : centerId ? [centerId] : [],
      order: ["id", "DESC"],
    };

    setLoader(true);

    listOfStaffApi(payload)
      .then((resp) => {
        if (checkStatusCodeSuccess(resp.statusCode)) {
          data = resp?.data?.listOfStaffDetail;

          setReportingManager(
            data?.map((item) => ({
              value: item?.id,

              label: item?.name,

              id: item?.id,
            })),
          );
        } else {
          staffForm.setFieldValue("reporting_manager", null);

          setReportingManager([]);

          toast.error(resp?.message);
        }
      })

      .catch((err) => {
        staffForm.setFieldValue("reporting_manager", null);

        setReportingManager([]);

        return err;
      })

      .finally(() => {
        setLoader(false);
      });

    setLoader(true);

    listOfHolidayApi(payload)
      .then((resp) => {
        if (checkStatusCodeSuccess(resp.statusCode)) {
          let data = resp?.data;

          setHolidayData(
            data?.map((item) => ({
              value: item?.id,

              label: item?.template_name,

              id: item?.id,
            })),
          );
        } else {
          staffForm.setFieldValue("holiday_template", null);

          setHolidayData([]);
        }
      })

      .catch((err) => {
        staffForm.setFieldValue("holiday_template", null);

        setHolidayData([]);

        return err;
      })

      .finally(() => {
        setLoader(false);
      });

    listOfLeaveTemplateApi(payload)
      .then((resp) => {
        if (checkStatusCodeSuccess(resp.statusCode)) {
          let data = resp?.data;

          setLeaveData(
            data?.map((item) => ({
              value: item?.id,

              label: item?.leave_template_name,

              id: item?.id,
            })),
          );
        } else {
          staffForm.setFieldValue("leave_template", null);

          setLeaveData([]);
        }
      })

      .catch((err) => {
        staffForm.setFieldValue("leave_template", null);

        setLeaveData([]);

        return err;
      })

      .finally(() => {
        setLoader(false);
      });

    listOfShiftApi(payload)
      .then((resp) => {
        if (checkStatusCodeSuccess(resp.statusCode)) {
          let data = resp?.data;

          setShiftData(
            data?.map((item) => ({
              value: item?.id,

              label: item?.shift_name,

              id: item?.id,
            })),
          );
        } else {
          staffForm.setFieldValue("shift", null);

          setShiftData([]);
        }
      })

      .catch((err) => {
        staffForm.setFieldValue("shift", null);

        setShiftData([]);

        return err;
      })

      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (isProfile) {
      setItem(isUserProfile, JSON.stringify(true));
    } else {
      setItem(isUserProfile, JSON.stringify(false));
    }

    setEditProfileMode(false);

    setEditGeneralMode(false);

    setEditPersonalMode(false);

    setEditEmploymentMode(false);

    setEditBankMode(false);

    setViewBankMode(!isAddStaff);

    setViewEmploymentMode(!isAddStaff);

    setViewGeneralMode(!isAddStaff);

    setViewPersonalMode(!isAddStaff);

    setViewProfileMode(!isAddStaff);
  }, [isProfile, isAddStaff]);

  const currentOrgId =
    isSuperAdmin && location.state?.organizationId
      ? location.state?.organizationId
      : localStorage.getItem("organizationId")
        ? Number(localStorage.getItem("organizationId"))
        : null;

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode, isProfile, currentOrgId, selectedOrganization]);

  useEffect(() => {
    // Fetch districts whenever staffData loads so they're available in both view and edit mode
    if (staffData && !isAddStaff) {
      const currentStateId = staffData?.staffAddress?.find(
        (a) => a.address_type === hrEnums.CURRENT_ADDRESS,
      )?.state?.id;
      const permanentStateId = staffData?.staffAddress?.find(
        (a) => a.address_type === hrEnums.PERMANENT_ADDRESS,
      )?.state?.id;
      if (currentStateId) fetchDistrict(currentStateId);
      if (permanentStateId && permanentStateId !== currentStateId) fetchDistrict(permanentStateId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staffData]);

  useEffect(() => {
    if (location.state && location.state.viewProfileMode !== undefined) {
      setViewProfileMode(location.state.viewProfileMode);
    }

    if (location.state && location.state.viewGeneralMode !== undefined) {
      setViewGeneralMode(location.state.viewGeneralMode);
    }

    if (location.state && location.state.viewPersonalMode !== undefined) {
      setViewPersonalMode(location.state.viewPersonalMode);
    }

    if (location.state && location.state.viewEmploymentMode !== undefined) {
      setViewEmploymentMode(location.state.viewEmploymentMode);
    }

    if (location.state && location.state.viewBankMode !== undefined) {
      setViewBankMode(location.state.viewBankMode);
    }
  }, [location.state]);

  const handlePhysicalChange = (event) => {
    setSelectedPhysical(event?.target?.value);

    staffForm.setFieldValue("physically_challenged", event?.target?.value);
  };

  const handleGenderChange = (event) => {
    setSelectedGender(event?.target?.value);

    staffForm.setFieldValue("gender", event?.target?.value);
  };

  const handleMultiCenter = (selectedMultiCenter) => {
    const weeks =
      selectedMultiCenter?.length > 0
        ? selectedMultiCenter?.map((item) => {
            return item.value;
          })
        : null;

    setSelectedMultiCenter(selectedMultiCenter);

    staffForm.setFieldValue("center", weeks);
  };

  const handleMulti = (selectedMulti) => {
    const weeks =
      selectedMulti?.length > 0
        ? selectedMulti?.map((item) => {
            return item.value;
          })
        : null;

    setSelectedMulti(selectedMulti);

    staffForm.setFieldValue("week_off", weeks);
  };

  const handleMaritalStatus = (field, value) => {
    staffForm.setFieldValue(field, value);

    if (value !== hrEnums.MARRIED) {
      staffForm.setFieldValue("spouse_name", null);
    }
  };

  const getAddressData = (addressType, staffData) => {
    const address = staffData?.staffAddress?.find((addr) => addr.address_type === addressType);

    return {
      address_line_1: address?.address_line_1,

      address_line_2: address?.address_line_2,

      district: address?.district?.id,

      state: address?.state?.id,

      postal_code: address?.postal_code,
    };
  };

  const handleDocumentAdd = () => {
    staffForm.setFieldValue("documents", [
      ...staffForm.values.documents,
      { document_type: "", files: [{ file_name: "" }], mandatory: false },
    ]);
  };

  const handleDocumentRemove = (index) => {
    const entry = staffForm.values.documents[index];
    // Delete all uploaded files for this entry
    (entry?.files || []).forEach((f) => {
      if (f?.file_name) deleteUploadedfile(f.file_name, true, staff);
    });
    staffForm.setFieldValue("documents", removeAt(staffForm.values.documents, index));
  };

  const handleDocumentTypeChange = (index, value) => {
    const updated = [...staffForm.values.documents];
    updated[index] = { ...updated[index], document_type: value };
    staffForm.setFieldValue("documents", updated);
  };

  // Add an extra file slot to an existing document entry
  const handleDocumentFileAdd = (index) => {
    const updated = [...staffForm.values.documents];
    updated[index] = {
      ...updated[index],
      files: [...(updated[index].files || []), { file_name: "" }],
    };
    staffForm.setFieldValue("documents", updated);
  };

  // Remove a specific file from a document entry
  const handleDocumentFileRemove = (entryIndex, fileIndex) => {
    const updated = [...staffForm.values.documents];
    const entry = updated[entryIndex];
    const fileToRemove = entry.files?.[fileIndex];
    if (fileToRemove?.file_name) deleteUploadedfile(fileToRemove.file_name, true, staff);
    updated[entryIndex] = {
      ...entry,
      files: removeAt(entry.files || [], fileIndex),
    };
    staffForm.setFieldValue("documents", updated);
  };

  const handleDocumentFileChange = (entryIndex, fileIndex, file) => {
    const validation = validateFileForUpload(file);
    if (!validation.valid) {
      const currentTouched = staffForm.touched.documents ? [...staffForm.touched.documents] : [];
      while (currentTouched.length <= entryIndex) currentTouched.push({});
      currentTouched[entryIndex] = { ...currentTouched[entryIndex], files: true };
      staffForm.setTouched({ ...staffForm.touched, documents: currentTouched });
      const currentErrors = staffForm.errors.documents ? [...staffForm.errors.documents] : [];
      while (currentErrors.length <= entryIndex) currentErrors.push({});
      currentErrors[entryIndex] = { ...currentErrors[entryIndex], files: validation.error };
      staffForm.setErrors({ ...staffForm.errors, documents: currentErrors });
      return;
    }
    const uploadKey = `${entryIndex}-${fileIndex}`;
    setUploadingIndex(uploadKey);
    const formData = new FormData();
    formData.append("files", file);
    formData.append("folderName", staff);
    fileUploadApi(formData)
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          const updated = [...staffForm.values.documents];
          const files = [...(updated[entryIndex].files || [])];
          files[fileIndex] = { file_name: resp?.data[0] };
          updated[entryIndex] = { ...updated[entryIndex], files };
          staffForm.setFieldValue("documents", updated);
        } else {
          toast.error(resp?.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message);
      })
      .finally(() => {
        setUploadingIndex(null);
      });
  };

  const currentAddress = getAddressData(hrEnums.CURRENT_ADDRESS, staffData);

  const permanentAddress = getAddressData(hrEnums.PERMANENT_ADDRESS, staffData);

  const profileValidation = {
    first_name: yup

      .string()

      .required(validationMessages.required(hrEnums.FIRST_NAME)),

    middle_name: yup.string().notRequired(),

    last_name: yup

      .string()

      .required(validationMessages.required(hrEnums.LAST_NAME)),

    designation:
      !isProfile &&
      !isSuperAdmin &&
      yup.number().required(validationMessages.required(Designation)),

    role: !isProfile && yup.number().required(validationMessages.required(hrEnums.ROLE)),

    staff_type: yup

      .string()

      .required(validationMessages.required(hrEnums.STAFF_TYPE)),

    email: yup

      .string()

      .email(validationMessages.format(Email))

      .required(validationMessages.required(Email)),

    contact_no: yup

      .string()

      .required(validationMessages.required(ContactNo))

      .matches(numberRegex, validationMessages.contactLength(ContactNo, 10)),

    center: !isProfile && yup.array().required(validationMessages.required(hrEnums.CENTER)),

    primary_center_id:
      !isProfile &&
      yup

        .string()

        .required(validationMessages.required(hrEnums.PRIMARY_CENTER)),
  };

  const personalValidation = {
    gender: yup.string().required(validationMessages.required(hrEnums.GENDER)),

    dob: yup

      .date()

      .max(
        new Date(new Date().setDate(new Date().getDate() - 1)),

        hrEnums.DOB_VALIDATION,
      )

      .required(validationMessages.required(hrEnums.DOB)),

    emergency_contact: yup

      .string()

      .nullable()

      .matches(
        numberRegex,

        validationMessages.contactLength(hrEnums.EMERGENCY_CONTACT, 10),
      ),

    postal_code: yup

      .string()

      .notRequired()

      .matches(
        zipcodeRegex,

        validationMessages.contactLength(hrEnums.POSTAL_CODE, 6),
      ),

    permanent_postal_code: yup

      .string()

      .notRequired()

      .matches(
        zipcodeRegex,

        validationMessages.contactLength(hrEnums.POSTAL_CODE, 6),
      ),
  };

  const generalValidation = {
    week_off: !isProfile && yup.array().notRequired(),

    holiday_template:
      !isProfile &&
      yup

        .number()

        .required(validationMessages.required(hrEnums.HOLIDAY_TEMPLATE)),

    leave_template:
      !isProfile &&
      yup

        .number()

        .required(validationMessages.required(hrEnums.LEAVE_TEMPLATE)),

    shift: !isProfile && yup.string().required(validationMessages.required(hrEnums.SHIFT)),

    salary_access:
      !isProfile && yup.string().required(validationMessages.required(hrEnums.SALARY_ACCESS)),
  };

  const employeeValidation = {
    joining_date: yup

      .date()

      .required(validationMessages.required(hrEnums.JOINING_DATE)),

    uan: yup

      .string()

      .notRequired()

      .matches(aadharRegex, validationMessages.contactLength(hrEnums.UAN, 12)),

    pan: yup

      .string()

      .notRequired()

      .matches(panRegex, validationMessages.contactLength(hrEnums.PAN, 10)),

    aadhar_number: yup

      .string()

      .notRequired()

      .matches(
        aadharRegex,

        validationMessages.contactLength(hrEnums.AADHAR_NUMBER, 12),
      ),

    monthly_salary: !isEditMode
      ? yup

          .string()

          .required(validationMessages.required(hrEnums.MONTHLY_SALARY))
      : yup.string().notRequired(),
  };

  const bankValidation = {
    ifsc: yup

      .string()

      .nullable()

      .matches(
        ifscRegex,

        validationMessages.contactLength(hrEnums.IFSC_CODE, 11),
      ),

    account_number: yup

      .string()

      .nullable()

      .min(8, validationMessages.minLength(hrEnums.ACCOUNT_NO, 8))

      .max(17, validationMessages.maxLength(hrEnums.ACCOUNT_NO, 17)),
  };

  const staffForm = useFormik({
    enableReinitialize: true,

    initialValues: {
      //profile section

      first_name: isEditMode ? staffData?.first_name : null,

      middle_name: isEditMode ? staffData?.middle_name : null,

      last_name: isEditMode ? staffData?.last_name : null,

      email: isEditMode ? staffData?.email : null,

      contact_no: isEditMode ? staffData?.contact_no : null,

      designation: isEditMode ? staffData?.position?.id : null,

      role: isEditMode ? staffData?.roleModel?.id : null,

      staff_type: isEditMode ? staffData?.staff_type || hrEnums.REGULAR : hrEnums.REGULAR,

      subscription: isEditMode ? staffData?.staffGeneralInformation?.subscription_id : null,

      organization: isEditMode
        ? (staffData?.organization?.id ??
          staffData?.organizationId ??
          staffData?.staffGeneralInformation?.organization_id ??
          staffData?.staffGeneralInformation?.organization?.id)
        : isSuperAdmin && (location.state?.organizationId || selectedOrganization)
          ? location.state?.organizationId || selectedOrganization
          : !isSuperAdmin && localStorage.getItem("organizationId")
            ? Number(localStorage.getItem("organizationId"))
            : null,

      center: isEditMode
        ? staffData?.center?.map((item) => item?.id)
        : selectedCenter
          ? [selectedCenter]
          : null,

      primary_center_id: isEditMode ? staffData?.primary_center_id : selectedCenter || null,

      reporting_manager: isEditMode ? staffData?.reportingTo?.id : null,

      repo: isEditMode ? staffData?.reportingTo?.id : null,

      // general section

      week_off: isEditMode ? staffData?.assignedWeekOff?.map((item) => item?.week_off) : null,

      holiday_template: isEditMode ? staffData?.staffGeneralInformation?.holiday?.id : null,

      leave_template: isEditMode ? staffData?.staffGeneralInformation?.leave?.id : null,

      shift: isEditMode ? staffData?.staffGeneralInformation?.shift?.id : null,

      salary_access: isEditMode ? staffData?.staffGeneralInformation?.salary_access : null,

      attendance_mode: isEditMode
        ? staffData?.staffGeneralInformation?.attendance_mode
        : attendaceMode,

      staff_id: isEditMode ? staffData?.staffGeneralInformation?.staff_id : currentStaffId,

      is_applicable_for_overtime: isEditMode
        ? String(staffData?.staffGeneralInformation?.is_applicable_for_overtime ?? false)
        : "false",

      //personal section

      gender: isEditMode ? staffData?.staffGeneralInformation?.gender : hrEnums.MALE,

      dob: isEditMode ? staffData?.staffGeneralInformation?.dob : null,

      marital_status: isEditMode ? staffData?.staffGeneralInformation?.marital_status : null,

      blood_group: isEditMode ? staffData?.staffGeneralInformation?.blood_group : null,

      emergency_contact: isEditMode ? staffData?.staffGeneralInformation?.emergency_contact : null,

      father_name: isEditMode ? staffData?.staffGeneralInformation?.father_name : null,

      mother_name: isEditMode ? staffData?.staffGeneralInformation?.mother_name : null,

      spouse_name: isEditMode ? staffData?.staffGeneralInformation?.spouse_name : null,

      physically_challenged: isEditMode
        ? staffData?.staffGeneralInformation?.physically_challenged
        : hrEnums.NO,

      address_line1: isEditMode ? currentAddress.address_line_1 : null,

      address_line2: isEditMode ? currentAddress.address_line_2 : null,

      district: isEditMode ? currentAddress.district : null,

      state: isEditMode ? currentAddress.state : null,

      postal_code: isEditMode ? currentAddress.postal_code : null,

      permanent_address_line1: isEditMode ? permanentAddress.address_line_1 : null,

      permanent_address_line2: isEditMode ? permanentAddress.address_line_2 : null,

      permanent_district: isEditMode ? permanentAddress.district : null,

      permanent_state: isEditMode ? permanentAddress.state : null,

      permanent_postal_code: isEditMode ? permanentAddress.postal_code : null,

      //employment section

      joining_date: isEditMode ? staffData?.staffGeneralInformation?.date_of_joining : null,

      uan: isEditMode ? staffData?.staffGeneralInformation?.uan_no : null,

      pan: isEditMode ? staffData?.staffGeneralInformation?.pan_no : null,

      aadhar_number: isEditMode ? staffData?.staffGeneralInformation?.aadhar_no : null,

      //bank section

      bank_name: isEditMode ? staffData?.staffBankDetails?.name_of_bank : null,

      ifsc: isEditMode ? staffData?.staffBankDetails?.IFSC_code : null,

      account_number: isEditMode ? staffData?.staffBankDetails?.account_no : null,

      account_holder_name: isEditMode ? staffData?.staffBankDetails?.account_holder_name : null,

      documents: (() => {
        // Mandatory seeds — always present, pre-filled type, can't be removed
        const mandatorySeeds = MANDATORY_DOCUMENT_TYPES.map((m) => ({
          document_type: m.value,
          files: [{ file_name: "" }],
          mandatory: true,
        }));

        if (!isEditMode) return mandatorySeeds;

        // Load from new identify_document format (from BE)
        // identify_document and aadhaar_card are at the root of staffData (data object)
        const identifyDoc = staffData?.identify_document;
        let existing = [];

        if (identifyDoc && typeof identifyDoc === "object" && Object.keys(identifyDoc).length > 0) {
          existing = parseIdentifyDocument(identifyDoc);
        } else {
          // Fallback: legacy other_documents array or single other_document string
          const arr = staffData?.staffGeneralInformation?.other_documents;
          if (Array.isArray(arr) && arr.length > 0) {
            existing = arr[0]?.files ? arr : migrateFlatDocuments(arr);
          } else {
            const legacy = staffData?.staffGeneralInformation?.other_document;
            if (legacy) existing = migrateLegacyDocument(legacy);
          }
        }

        // Also load aadhaar_card from root staffData (API returns it at root level)
        const aadhaarFromProfile = staffData?.aadhaar_card;
        if (aadhaarFromProfile && !existing.find((e) => e.document_type === "aadhaar_card")) {
          existing = [
            {
              document_type: "aadhaar_card",
              files: [{ file_name: aadhaarFromProfile }],
              mandatory: true,
            },
            ...existing,
          ];
        }

        // Merge mandatory: use existing uploaded entry if found, else seed empty
        const merged = MANDATORY_DOCUMENT_TYPES.map((m) => {
          const found = existing.find((e) => e.document_type === m.value);
          return found
            ? { ...found, mandatory: true }
            : { document_type: m.value, files: [{ file_name: "" }], mandatory: true };
        });

        // Append optional existing entries (non-mandatory types)
        const optional = existing.filter((e) => !MANDATORY_DOC_VALUES.has(e.document_type));
        return [...merged, ...optional.map((e) => ({ ...e, mandatory: false }))];
      })(),
    },

    validationSchema: yup.object({
      ...(!viewProfileMode ? profileValidation : {}),
      ...(!isSuperAdmin && !viewPersonalMode ? personalValidation : {}),
      ...(!isSuperAdmin && !viewGeneralMode ? generalValidation : {}),
      ...(!isSuperAdmin && !viewBankMode ? bankValidation : {}),
      ...(!isSuperAdmin && !viewEmploymentMode ? employeeValidation : {}),
      ...(!isSuperAdmin && (!viewEmploymentMode || isAddStaff)
        ? {
            documents: yup
              .array()
              .of(
                yup.object().shape({
                  document_type: yup.string().required(),
                  files: yup.array().of(
                    yup.object().shape({
                      file_name: yup.string(),
                    }),
                  ),
                  mandatory: yup.boolean(),
                }),
              )
              .test("mandatory-check", "Aadhaar Card is required", function (value) {
                if (!value) return true;

                const validationErrors = [];
                let hasError = false;

                value.forEach((doc, idx) => {
                  if (doc.mandatory) {
                    const hasFile =
                      doc.files && doc.files.some((f) => f?.file_name && f.file_name.trim() !== "");
                    if (!hasFile) {
                      hasError = true;
                      const docType = MANDATORY_DOCUMENT_TYPES.find(
                        (m) => m.value === doc.document_type,
                      );
                      const docLabel = docType ? docType.label : "Document";
                      validationErrors.push(
                        this.createError({
                          path: `${this.path}[${idx}].files`,
                          message: docLabel + " is required",
                        }),
                      );
                    }
                  }
                });

                if (hasError) {
                  return new yup.ValidationError(validationErrors);
                }
                return true;
              }),
          }
        : {}),
    }),

    validateOnBlur: true,

    validateOnChange: true,

    onSubmit: (values) => {
      const payload = {
        staffProfile: {
          first_name: values.first_name,
          middle_name: values.middle_name,
          last_name: values.last_name,
          email: values.email,
          position_id: values.designation,
          center_ids: values.center,
          primary_center_id: values.primary_center_id,
          staff_type: values.staff_type,
          contact_no: values.contact_no,
          reporting_to: values.reporting_manager,
          role_id: values.role,
          subscription_id: values.subscription,
          organizationId: values.organization,
        },

        staffGeneralInformation: {
          staff_id: values.staff_id,
          holiday_template_id: values.holiday_template,
          leave_template_id: values.leave_template,
          shift_id: values.shift,
          salary_access: values.salary_access,
          attendance_mode: values.attendance_mode,
          week_off: values.week_off?.length > 0 ? values.week_off : [],
          date_of_joining: values.joining_date,
          uan_no: values.uan,
          pan_no: values.pan,
          aadhar_no: values.aadhar_number,
          gender: values.gender,
          dob: values.dob,
          marital_status: values.marital_status,
          blood_group: values.blood_group,
          emergency_contact: values.emergency_contact,
          physically_challenged: values.physically_challenged,
          father_name: values.father_name,
          mother_name: values.mother_name,
          spouse_name: values.spouse_name,
          is_applicable_for_overtime: values.is_applicable_for_overtime === "true",
        },

        staffAddress: [
          {
            address_type: hrEnums.CURRENT_ADDRESS,
            address_line_1: values.address_line1 === "" ? null : values.address_line1,
            address_line_2: values.address_line2 === "" ? null : values.address_line2,
            state_id: values.state,
            district_id: values.district,
            postal_code: values.postal_code ? values.postal_code : null,
          },
          {
            address_type: hrEnums.PERMANENT_ADDRESS,
            address_line_1:
              values.permanent_address_line1 === "" ? null : values.permanent_address_line1,
            address_line_2:
              values.permanent_address_line2 === "" ? null : values.permanent_address_line2,
            state_id: values.permanent_state,
            district_id: values.permanent_district,
            postal_code: values.permanent_postal_code ? values.permanent_postal_code : null,
          },
        ],

        staffBankDetails: {
          name_of_bank: values.bank_name === "" ? null : values.bank_name,
          IFSC_code: values.ifsc === "" ? null : values.ifsc,
          account_no: values.account_number === "" ? null : values.account_number,
          account_holder_name:
            values.account_holder_name === "" ? null : values.account_holder_name,
        },

        staffSalaryDetails: {
          monthly_special_allowance:
            values.monthly_special_allowance === "" ? null : values.monthly_special_allowance,
          monthly_salary: values.monthly_salary,
        },

        // Backend requires otherDocument even if empty
        otherDocument: { other_document: null },
      };

      // Inject aadhaar_card + identify_document into staffProfile section
      const { aadhaarFile, identifyDocument } = buildDocumentPayload(values.documents);
      if (payload.staffProfile) {
        if (aadhaarFile) {
          payload.staffProfile.aadhaar_card = aadhaarFile;
        }
        if (identifyDocument && Object.keys(identifyDocument).length > 0) {
          payload.staffProfile.identify_document = identifyDocument;
        }
      }

      if (staffId || isProfile) {
        setBtnLoader(true);

        editStaffApi(isProfile ? profileId : staffId, payload)
          .then((resp) => {
            if (checkStatusCodeSuccess(resp.statusCode)) {
              toast.success(resp?.message);

              handleProfileDiscard();

              handleGeneralDiscard();

              handlePersonalDiscard();

              handleEmploymentDiscard();

              handleBankDiscard();

              staffForm.resetForm();
            } else {
              toast.error(resp?.message);
            }
          })

          .catch((err) => {
            if (Array.isArray(err?.response?.data?.message)) {
              err?.response?.data?.message?.map((message) => {
                toast.error(message);
              });
            } else {
              toast.error(err?.response?.data?.message || err?.message);
            }

            return err;
          })

          .finally(() => {
            setBtnLoader(false);
          });
      } else {
        setBtnLoader(true);

        addStaffApi(payload)
          .then((resp) => {
            if (checkStatusCodeSuccess(resp?.statusCode)) {
              toast.success(resp?.message);

              if (isOnboarding && onSuccess) {
                onSuccess();
              } else {
                navigate("/staff");
              }

              staffForm.resetForm();
            } else {
              toast.error(resp?.message);
            }
          })

          .catch((err) => {
            if (Array.isArray(err?.response?.data?.message)) {
              err?.response?.data?.message?.map((message) => {
                toast.error(message);
              });
            } else {
              toast.error(err?.response?.data?.message || err?.message);
            }
          })

          .finally(() => {
            setBtnLoader(false);
          });
      }
    },
  });

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role !== SuperAdmin && role !== Admin) return;

    const orgId = staffForm.values.organization;
    if (orgId) {
      viewOrganizationApi(orgId)
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.statusCode)) {
            setOvertimePolicyType(resp?.data?.organization?.overtime_policy_type || null);
          } else {
            setOvertimePolicyType(null);
          }
        })
        .catch(() => {
          setOvertimePolicyType(null);
        });
    } else {
      setOvertimePolicyType(null);
    }
  }, [staffForm.values.organization]);

  useEffect(() => {
    if (!isEditMode && isAddStaff && selectedCenter && centerData.length > 0) {
      const matchedCenter = centerData.find((c) => c.value === selectedCenter);
      if (matchedCenter && selectedMultiCenter?.length === 0) {
        setSelectedMultiCenter([matchedCenter]);
        setSelectedCenterIds([matchedCenter]);
        staffForm.setFieldValue("center", [selectedCenter]);
        staffForm.setFieldValue("primary_center_id", selectedCenter);
      }
    }
  }, [centerData, selectedCenter, isEditMode, isAddStaff, selectedMultiCenter?.length, staffForm]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = await staffForm.validateForm();

    const touchedFields = {};
    Object.keys(errors).forEach((key) => {
      if (key === "documents" && Array.isArray(staffForm.values.documents)) {
        touchedFields.documents = staffForm.values.documents.map((doc, idx) => {
          return errors.documents[idx] ? { files: true } : {};
        });
      } else {
        touchedFields[key] = true;
      }
    });

    staffForm.setTouched(touchedFields);

    if (Object.keys(errors).length > 0) {
      openSectionWithError(errors);

      staffForm.handleSubmit();
    } else {
      staffForm.handleSubmit();
    }
  };

  const openSectionWithError = (errors) => {
    const firstErrorField = Object.keys(errors)[0];

    if (isEditMode) {
      const sectionToOpen = Object.keys(fieldToSectionMap).find((section) =>
        fieldToSectionMap[section].includes(firstErrorField),
      );

      switch (sectionToOpen) {
        case formFields.profile_section:
          setEditProfileMode(true);

          setViewProfileMode(false);

          break;

        case formFields.personal_section:
          setEditPersonalMode(true);

          setViewPersonalMode(false);

          break;

        case formFields.general_section:
          setEditGeneralMode(true);

          setViewGeneralMode(false);

          break;

        case formFields.bank_section:
          setEditBankMode(true);

          setViewBankMode(false);

          break;

        case formFields.employment_section:
          setEditEmploymentMode(true);

          setViewPersonalMode(false);

          break;

        default:
          break;
      }
    }

    const element = document.getElementById(firstErrorField);

    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });

      element.focus();
    }
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const handleResetEmail = () => {
    if (!newEmail) {
      setResetEmailError(validationMessages.required(Email));
      return;
    }
    if (!emailRegex.test(newEmail)) {
      setResetEmailError(validationMessages.format(Email));
      return;
    }
    setResetEmailError("");
    setResetEmailLoader(true);
    resetEmailApi(staffId, { email: newEmail })
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          toast.success(resp?.message || "Email reset successfully.");
          setShowResetEmailModal(false);
          fetchData();
        } else {
          toast.error(resp?.message || "Failed to reset email.");
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message || "Something went wrong.");
      })
      .finally(() => {
        setResetEmailLoader(false);
      });
  };

  useEffect(() => {
    if (isChecked) {
      staffForm.setFieldValue(
        "permanent_address_line1",

        staffForm.values.address_line1,
      );

      staffForm.setFieldValue(
        "permanent_address_line2",

        staffForm.values.address_line2,
      );

      staffForm.setFieldValue("permanent_state", staffForm.values.state);

      staffForm.setFieldValue("permanent_district", staffForm.values.district);

      staffForm.setFieldValue(
        "permanent_postal_code",

        staffForm.values.postal_code,
      );
    } else {
      staffForm.setFieldValue(
        "permanent_address_line1",

        isEditMode ? permanentAddress.address_line_1 : null,
      );

      staffForm.setFieldValue(
        "permanent_address_line2",

        isEditMode ? permanentAddress.address_line_2 : null,
      );

      staffForm.setFieldValue(
        "permanent_state",

        isEditMode ? permanentAddress.state : null,
      );

      staffForm.setFieldValue(
        "permanent_district",

        isEditMode ? permanentAddress.district : null,
      );

      staffForm.setFieldValue(
        "permanent_postal_code",

        isEditMode ? permanentAddress.postal_code : null,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    staffForm.values.address_line1,

    staffForm.values.address_line2,

    staffForm.values.state,

    staffForm.values.district,

    staffForm.values.postal_code,

    isChecked,
  ]);

  useEffect(() => {
    if (staffForm.values?.center !== null && centerData?.length > 0) {
      const matchedCenters = [];

      centerData?.filter((item) => {
        staffForm.values.center?.map((value) => {
          if (item?.value === value) {
            matchedCenters?.push(item);

            return value;
          }
        });
      });

      setSelectedCenterIds(matchedCenters);
    } else {
      setSelectedCenterIds([]);
    }
  }, [staffForm.values.center, isEditMode, centerData]);

  useEffect(() => {
    if (isEditMode || isAddStaff) {
      if (
        staffForm.values.center !== null &&
        staffForm.values.primary_center_id !== null &&
        !staffForm.values.center?.includes(staffForm.values.primary_center_id)
      ) {
        staffForm.setFieldValue("primary_center_id", null);

        fetchReportingManager(null);

        staffForm.setTouched({
          primary_center_id: true,

          reporting_manager: true,

          leave_template: true,

          holiday_template: true,

          shift: true,
        });

        staffForm.validateForm();
      } else {
        fetchReportingManager(staffForm.values.primary_center_id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staffForm.values.center, staffForm.values.primary_center_id]);

  const isViewedAdmin = React.useMemo(() => {
    if (isProfile) {
      return localStorage.getItem("role")?.trim()?.toLowerCase() === "admin";
    }
    const selectedRoleName =
      roleData.find((r) => Number(r.value) === Number(staffForm.values.role))?.label ||
      staffData?.roleModel?.role_name;
    return selectedRoleName?.trim()?.toLowerCase() === "admin";
  }, [isProfile, roleData, staffForm.values.role, staffData]);

  return (
    <div className="animate-fade-in" style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {/* ── Page header ── */}
      {!isOnboarding && (
        <div
          className="animate-slide-down"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div>
            <h1
              style={{
                fontSize: "1.375rem",
                fontWeight: 800,
                margin: 0,
                color: "var(--text-primary)",
              }}
            >
              {isAddStaff ? "Add Staff" : staffData?.name || "Staff Profile"}
            </h1>
            {staffData?.staffGeneralInformation?.staff_id && (
              <p
                style={{
                  margin: "4px 0 0",
                  fontSize: "0.8125rem",
                  color: "var(--text-muted)",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                <span
                  style={{
                    fontFamily: "monospace",
                    background: "var(--icon-btn-bg)",
                    padding: "2px 8px",
                    borderRadius: 6,
                    border: "1px solid var(--glass-border)",
                    fontSize: "0.75rem",
                    fontWeight: 700,
                    color: "var(--brand-indigo)",
                  }}
                >
                  {staffData.staffGeneralInformation.staff_id}
                </span>
                {staffData?.position?.position_name && (
                  <span style={{ color: "var(--text-muted)" }}>
                    · {staffData.position.position_name}
                  </span>
                )}
              </p>
            )}
          </div>
          {!isProfile && rendorBackButton(() => navigate("/staff"))}
        </div>
      )}

      {/* ── Form sections ── */}
      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 0 }}>
        <ProfileDetails
          staffForm={staffForm}
          viewProfileMode={viewProfileMode}
          handleProfileEdit={handleProfileEdit}
          handleProfileDiscard={handleProfileDiscard}
          editProfileMode={editProfileMode}
          positionData={positionData}
          roleData={roleData}
          centerData={centerData}
          staffData={staffData}
          btnLoader={btnLoader}
          fetchReportingManager={fetchReportingManager}
          reportingManager={reportingManager}
          currentStaffId={currentStaffId}
          lastStaffId={lastStaffId}
          isEditMode={isEditMode}
          selectedMultiCenter={selectedMultiCenter}
          handleMultiCenter={handleMultiCenter}
          isProfile={isProfile}
          selectedCenterIds={selectedCenterIds}
          subscriptionData={subscriptionList}
          organizationData={organizationList}
          organizationCenters={organizationCenters}
          handleOrganizationChange={handleOrganizationChange}
          organizationDesignations={organizationDesignations}
          isSuperAdmin={isSuperAdmin}
          globalOrgId={selectedOrganization}
          globalCenterId={selectedCenter}
          onResetEmailClick={() => {
            setNewEmail(staffData?.email || "");
            setResetEmailError("");
            setShowResetEmailModal(true);
          }}
        />
        {!isSuperAdmin && !isViewedAdmin && (
          <GeneralDetails
            staffForm={staffForm}
            viewGeneralMode={viewGeneralMode}
            handleGeneralEdit={handleGeneralEdit}
            handleGeneralDiscard={handleGeneralDiscard}
            editGeneralMode={editGeneralMode}
            btnLoader={btnLoader}
            staffData={staffData}
            handleMulti={handleMulti}
            selectedMulti={selectedMulti}
            holidayData={holidayData}
            leaveData={leaveData}
            shiftData={shiftData}
            isEditMode={isEditMode}
            isProfile={isProfile}
            overtimePolicyType={overtimePolicyType}
          />
        )}
        {!isSuperAdmin && !isViewedAdmin && (
          <PersonalDetails
            staffForm={staffForm}
            viewPersonalMode={viewPersonalMode}
            handlePersonalEdit={handlePersonalEdit}
            handlePersonalDiscard={handlePersonalDiscard}
            editPersonalMode={editPersonalMode}
            handlePhysicalChange={handlePhysicalChange}
            handleGenderChange={handleGenderChange}
            selectedGender={selectedGender}
            selectedPhysical={selectedPhysical}
            btnLoader={btnLoader}
            fetchDistrict={fetchDistrict}
            district={district}
            states={states}
            staffData={staffData}
            handleMaritalStatus={handleMaritalStatus}
            addressDetails={addressDetails}
            handleCheckboxChange={handleCheckboxChange}
            isChecked={isChecked}
            permanentAddress={permanentAddress}
            currentAddress={currentAddress}
            isProfile={isProfile}
          />
        )}
        {!isSuperAdmin && !isViewedAdmin && (
          <BankDetails
            staffForm={staffForm}
            viewBankMode={viewBankMode}
            handleBankEdit={handleBankEdit}
            handleBankDiscard={handleBankDiscard}
            editBankMode={editBankMode}
            btnLoader={btnLoader}
            staffData={staffData}
            isProfile={isProfile}
            bankList={bankList}
          />
        )}
        {!isSuperAdmin && !isViewedAdmin && (
          <EmploymentDetails
            staffForm={staffForm}
            viewEmploymentMode={viewEmploymentMode}
            handleEmploymentEdit={handleEmploymentEdit}
            handleEmploymentDiscard={handleEmploymentDiscard}
            editEmploymentMode={editEmploymentMode}
            btnLoader={btnLoader}
            staffData={staffData}
            isEditMode={isEditMode}
            documents={staffForm.values.documents}
            onDocumentAdd={handleDocumentAdd}
            onDocumentRemove={handleDocumentRemove}
            onDocumentTypeChange={handleDocumentTypeChange}
            onDocumentFileChange={handleDocumentFileChange}
            onDocumentFileAdd={handleDocumentFileAdd}
            onDocumentFileRemove={handleDocumentFileRemove}
            uploadingIndex={uploadingIndex}
            documentErrors={staffForm.errors.documents}
            documentTouched={staffForm.touched.documents}
            isProfile={isProfile}
            onGenerateJoiningLetter={handleGenerateJoiningLetter}
            onGenerateExperienceLetter={handleGenerateExperienceLetterClick}
          />
        )}
        {isAddStaff && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              padding: "16px 20px",
              background: "var(--glass-bg)",
              border: "1px solid var(--glass-border)",
              borderRadius: 16,
              marginTop: 4,
            }}
          >
            <BaseButton
              color="primary"
              type="submit"
              loader={btnLoader}
              disabled={uploadingIndex !== null}
            >
              {Submit}
            </BaseButton>
          </div>
        )}
      </form>

      {/* ── Experience/Joining Letter Generation Modal ── */}
      <BaseModal
        isOpen={letterModal}
        title={letterType === "joining" ? "Generate Joining Letter" : "Generate Experience Letter"}
        toggler={() => setLetterModal(false)}
        submit={handleDownloadLetter}
        submitText="Generate & Download"
        disabled={letterModalLoader}
        loader={letterModalLoader}
      >
        <div
          style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}
        >
          {/* Scrollable content area - contains all form fields */}
          <div
            style={{
              flex: 1,
              minHeight: 0,
              overflow: "auto",
              paddingRight: 4,
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}
          >
            {/* Metadata configuration */}
            <div
              style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, flexShrink: 0 }}
            >
              <div>
                <label className="form-label d-block mb-1 text-secondary fw-semibold small">
                  Designation
                </label>
                <BaseInput
                  name="letterDesignation"
                  type="text"
                  placeholder="Designation"
                  value={letterDesignation}
                  handleChange={(e) => {
                    setLetterDesignation(e.target.value);
                    setLetterBody(
                      getDefaultLetterBody(
                        letterType,
                        staffData || JSON.parse(getItem("staffData")),
                        letterRelievingDate,
                        letterDate,
                        e.target.value,
                      ),
                    );
                  }}
                />
              </div>
              <div>
                <label className="form-label d-block mb-1 text-secondary fw-semibold small">
                  Letter Date
                </label>
                <BaseDatePicker
                  name="letterDate"
                  value={letterDate}
                  onChange={(d) => {
                    setLetterDate(d);
                    setLetterBody(
                      getDefaultLetterBody(
                        letterType,
                        staffData || JSON.parse(getItem("staffData")),
                        letterRelievingDate,
                        d,
                        letterDesignation,
                      ),
                    );
                  }}
                  placeholder="Select date"
                />
              </div>
            </div>

            {letterType === "experience" && (
              <div style={{ flexShrink: 0 }}>
                <label className="form-label d-block mb-1 text-secondary fw-semibold small">
                  Relieving Date (Last Working Day)
                </label>
                <BaseDatePicker
                  name="letterRelievingDate"
                  value={letterRelievingDate}
                  onChange={(d) => {
                    setLetterRelievingDate(d);
                    setLetterBody(
                      getDefaultLetterBody(
                        letterType,
                        staffData || JSON.parse(getItem("staffData")),
                        d,
                        letterDate,
                        letterDesignation,
                      ),
                    );
                  }}
                  placeholder="Select date"
                />
              </div>
            )}

            {/* Scrollable content area */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 8,
                flex: 1,
                minHeight: 0,
                overflow: "auto",
                paddingRight: 4,
              }}
            >
              {/* Letter Body Editor */}
              <div style={{ display: "flex", flexDirection: "column", gap: 4, flexShrink: 0 }}>
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <label className="form-label m-0 text-secondary fw-semibold small">
                    Letter Body Text
                  </label>
                  <BaseButton
                    type="button"
                    onClick={() =>
                      setLetterBody(
                        getDefaultLetterBody(
                          letterType,
                          staffData || JSON.parse(getItem("staffData")),
                          letterRelievingDate,
                          letterDate,
                          letterDesignation,
                        ),
                      )
                    }
                    color="link"
                    className="p-0 text-decoration-none shadow-none"
                    style={{
                      color: "var(--brand-indigo)",
                      fontSize: "0.7rem",
                      fontWeight: 600,
                    }}
                  >
                    Reset to Default
                  </BaseButton>
                </div>
                <BaseInput
                  type="textarea"
                  name="letterBody"
                  value={letterBody}
                  handleChange={(e) => setLetterBody(e.target.value)}
                  placeholder="Enter letter body text"
                  rows={12}
                  className="mb-0"
                />
              </div>

              {/* Signature and Stamp controls */}
              <div
                style={{
                  borderTop: "2px solid var(--glass-border)",
                  marginTop: 4,
                  paddingTop: 10,
                  display: "flex",
                  flexDirection: "column",
                  gap: 6,
                  flexShrink: 0,
                }}
              >
                <BaseCheckbox
                  id="includeSignature"
                  label="Include Digital Signature & Company Stamp"
                  checked={includeSignature}
                  onChange={(e) => setIncludeSignature(e.target.checked)}
                  className="d-flex align-items-center gap-2 mb-0"
                  labelClassName="mb-0 text-primary fw-medium fs-7"
                />

                {includeSignature && (
                  <div>
                    <label className="form-label d-block mb-1 text-secondary fw-semibold small">
                      Select Signatory Authority
                    </label>
                    <BaseSelect
                      name="signatory"
                      value={signatory}
                      handleChange={(name, val) => setSignatory(val)}
                      options={[
                        { value: "HR Manager", label: "HR Manager" },
                        { value: "Managing Director", label: "Managing Director" },
                        { value: "CEO", label: "CEO" },
                      ]}
                      mb="mb-0"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </BaseModal>

      <BaseModal
        isOpen={showResetEmailModal}
        toggler={() => setShowResetEmailModal(false)}
        title="Reset Staff Email"
        submit={handleResetEmail}
        submitText="Reset"
        loader={resetEmailLoader}
      >
        <div style={{ padding: "10px 0" }}>
          <p style={{ fontSize: "0.875rem", color: "var(--text-muted)", marginBottom: 16 }}>
            Enter the correct email address for this staff member. An email with their login
            credentials and instructions will be sent automatically to the new email address.
          </p>
          <BaseInput
            label={
              <>
                New Email Address
                <span className="text-danger ms-1">*</span>
              </>
            }
            name="newEmail"
            type="email"
            placeholder="Enter new email address"
            value={newEmail}
            handleChange={(e) => {
              setNewEmail(e.target.value);
              if (resetEmailError) setResetEmailError("");
            }}
            error={resetEmailError}
            touched={true}
          />
        </div>
      </BaseModal>
    </div>
  );
};

export default StaffProfile;
